interface HoneycombSpinnerProps {
  size?: number;
  className?: string;
}

export function HoneycombSpinner({ size = 32, className = "" }: HoneycombSpinnerProps) {
  return (
    <div className={`inline-block animate-spin ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Hexagon outline (plaster miodu) */}
        <polygon
          points="50,5 90,27.5 90,72.5 50,95 10,72.5 10,27.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Inner hexagon for depth */}
        <polygon
          points="50,15 80,32.5 80,67.5 50,85 20,67.5 20,32.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          opacity="0.5"
        />
      </svg>
    </div>
  );
}
